import type { Element } from "@xmpp/xml"

const PIPELINE_XMLNS = "urn:slickshift:agent-pipeline:0"

// The agent reports writing its answer as a step of its own. The live row
// under the answer already says the agent is at work, so this one only adds
// noise, in the row and in the finished turn's list.
const HIDDEN_TOOLS = new Set(["formatting"])

export type AgentStep = {
  // Unique per step invocation. Absent from agents older than the pipeline
  // step id contract; see agentPipelineSlice for the fallback keying.
  stepId?: string
  type: "delegation" | "tool_call"
  status: "started" | "done"
  name: string
  label: string
}

export function parseAgentStep(stanza: Element): AgentStep | undefined {
  const step = stanza.getChild("agent-step", PIPELINE_XMLNS)
  if (!step) return undefined

  const type = step.getAttr("type") as "delegation" | "tool_call"
  const status = step.getAttr("status") as "started" | "done"
  const name = step.getAttr("agent") ?? step.getAttr("tool") ?? ""
  if (type === "tool_call" && HIDDEN_TOOLS.has(name)) return undefined
  const label = step.getAttr("label") ?? name
  const stepId = step.getAttr("stepId") || undefined

  return { stepId, type, status, name, label }
}
